import { useQuery } from '@tanstack/react-query';
import { getChamps } from '../../api/CHAMPS/champs';

export const useGetChamps = () => {
  return useQuery({
    queryKey: ['champs'],
    queryFn: getChamps,
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
};
